import React from 'react'
import FontAwesome from 'react-fontawesome'
import '../layouts/fontawesome/font-awesome-4.7.0/css/font-awesome.css'
import styles from './Info.module.css'

const fact1 = '/pdf/FACT SHEET 1_VIF_Indikator.pdf'
const fact2 = '/pdf/FACT SHEET 2_VIF_Kriterien.pdf'

class Info extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      fix: false,
    }
  }

  render() {
    return (
      <div className={styles.i_symbol}>
        <FontAwesome
          className={styles.i_circle}
          name={this.state.fix ? 'thumb-tack' : 'info-circle'}
          onClick={() => this.setState({ fix: !this.state.fix })}
          style={
            this.state.fix
              ? { color: '#be0021', paddingLeft: '4px', paddingRight: '4px' }
              : null
          }
        />
        <div
          className={styles.i_popup}
          style={
            this.state.fix ? { display: 'block', boxShadow: 'initial' } : null
          }
        >
          <FontAwesome name="info-circle" style={{ color: '#9e9b98' }} />{' '}
          {this.props.location.match('.*Indikator') && (
            <span>
              Mithilfe des sogenannten VIF-Indikators wird in Österreich jene
              mit der Vollbeschäftigung der Eltern zu verein­barende, elementare
              Kinderbildung und -betreuung („VIF-Krite­rien“) sichtbar gemacht.{' '}
              <br />
              <a target="_blank" href={fact1}>
                Fact Sheet 1
              </a>
            </span>
          )}
          {this.props.location.match('.*Kriterien') && (
            <span>
              <a target="_blank" href={fact2}>
                Fact Sheet 2
              </a>
            </span>
          )}
        </div>
      </div>
    )
  }
}

export default Info



// WEBPACK FOOTER //
// ./src/components/Info.js